import { render } from "./HomePage.vue?vue&type=template&id=a78915da"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
script.render = render

export default script